import { Component, OnInit, Inject } from '@angular/core';
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';
//import { OrderService } from '../../../views/order/order.service';
import { DataService } from '../../services/data.service';
@Component({
  selector: 'app-app-notification',
  templateUrl: './app-notification.component.html',
  styleUrls: ['./app-notification.component.scss'],
})
export class AppNotificationComponent implements OnInit {
  currentUser: any = {};
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
   // private order: OrderService,
    private pass: DataService,
    private snackbarRef: MatSnackBarRef<AppNotificationComponent>
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  ngOnInit(): void {
    if (this.data.action) {
      this.pass.changeTotalSeen('ok');
    }
  }
  public close(event: Event) {
    event.stopPropagation();
    this.snackbarRef.dismiss();
  }
  public action() {
    if (this.data.action) {
      
      // if(this.data.action.idNotification){      
      //   this.order.updateReadStatusNotification(this.data.action.idNotification).subscribe((res) => {});
      //   this.pass.changeTypeLoad('1');
      // }
      // if(this.data.action.idReminder){      
      //   this.order.updateReadStatusReminder(this.data.action.idReminder).subscribe((res) => {});
      //   this.pass.changeTypeLoad('2');
      // }
      const duplicate = this.data.type === 'dup' ? '&duplicate=true' : '';
      window.open(`/order?id=${this.data.action.idOrder}${duplicate}`, 'blank');   

      this.snackbarRef.dismiss();
    } else {
      this.snackbarRef.dismiss();
    }
  }
}
